import { useCompleted } from 'views/pages/Worklist/AllWorklist/components/Completed/hooks';
import { Box, Typography } from '@mui/material';
import { FactCheck } from '@mui/icons-material';
import { t } from 'i18next';
import { TaskTable } from 'views/pages/Worklist';
import { IColumnDefinition } from 'common/types';
import {
  Filters,
  FiltersCard,
} from 'views/pages/Worklist/AllWorklist/components/Completed/Filters';

const columns: IColumnDefinition[] = [
  {
    id: 'task',
    label: 'Task',
    sortable: true,
  },
  {
    id: 'category',
    label: 'Category',
    sortable: true,
  },
  {
    id: 'patient',
    label: 'Patient',
    sortable: true,
  },
  {
    id: 'priority',
    label: 'Priority',
    sortable: true,
    align: 'center',
  },
  {
    id: 'due_date',
    label: 'Due date',
    sortable: true,
  },
  {
    id: 'status',
    label: 'Status',
    sortable: true,
  },
  {
    id: 'created_date',
    label: 'Created date',
    sortable: true,
  },
  {
    id: 'last_updated_at',
    label: 'Last updated',
    sortable: true,
  },
  {
    id: 'provider',
    label: 'Provider',
    sortable: true,
  },
  {
    id: 'location',
    label: 'Location',
    sortable: true,
  },
  {
    id: 'assignment',
    label: 'Assigned to',
    sortable: true,
  },
];

export const Completed = () => {
  const {
    isFiltersCardOpen,
    entries,
    isLoading,
    filters,
    handleCompletedFilterChange,
    totalCount,
    handleOpenTaskDetails,
    selectedTaskId,
    isInitialFilters,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
    handleFullResetCompletedFilters,
  } = useCompleted();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        flexDirection: 'row',
        gap: '1rem',
        width: '100%',
      }}
    >
      {isFiltersCardOpen && (
        <FiltersCard handleCloseFiltersCard={handleCloseFiltersCard} />
      )}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {entries.length === 0 && isInitialFilters && !isLoading ? (
          <Box
            sx={{
              height: 'calc(100vh - 300px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <FactCheck sx={{ width: 56, height: 56, mb: 2 }} color='primary' />
            <Typography variant='h6'>
              {t('worklist.table.noResults.title')}
            </Typography>
            <Typography variant='body2' sx={{ color: 'text.disabled' }}>
              {t('worklist.table.noResults.subTitle')}
            </Typography>
          </Box>
        ) : (
          <>
            <Filters
              isFiltersCardOpen={isFiltersCardOpen}
              handleToggleFiltersCard={handleToggleFiltersCard}
            />
            <TaskTable
              rows={entries}
              columns={columns}
              filters={filters}
              setFilters={handleCompletedFilterChange}
              totalCount={totalCount}
              onSelectTask={handleOpenTaskDetails}
              loading={isLoading}
              selectedTaskId={selectedTaskId}
              isCompletedTab
              onResetAction={handleFullResetCompletedFilters}
            />
          </>
        )}
      </Box>
    </Box>
  );
};
